import { render, staticRenderFns } from "./ResetActionsCCure.vue?vue&type=template&id=55ce1947&scoped=true"
import script from "./ResetActionsCCure.vue?vue&type=script&lang=ts"
export * from "./ResetActionsCCure.vue?vue&type=script&lang=ts"
import style0 from "./ResetActionsCCure.vue?vue&type=style&index=0&id=55ce1947&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce1947",
  null
  
)

export default component.exports